import React from "react";
import Header from "../../layout/Header";
import PackageBar from "./sections/PackageBar";
import LeftBar from "../leftBar/LeftBar"

export default function PackageDetails() {
  return (
    <>
      <section className="font-soehne">
        <Header />
        <section className="lg:py-20 py-10 w-11/12 xl:w-[90%]  mx-auto lg:grid lg:grid-cols-12">
          <LeftBar />
          <PackageBar />
        </section>
      </section>
    </>
  );
}
